var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgAdvanced9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 344,
    viewBox: "0 0 586 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_131_26",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 586,
    height: 344
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 344,
    rx: 15,
    fill: "url(#paint0_linear_131_26)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_131_26)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M-1.67502 192.225C81.1081 187.996 107.535 245.143 238.128 221.4C342.261 202.47 387.091 273.147 400.059 317.055C406.248 338.034 407.82 420.029 350.677 421.2C156.753 425.233 1.37038 637.751 -92.1208 451.904C-130.041 376.511 -189.607 201.852 -1.67502 192.225Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M461.325 -201.775C544.108 -206.004 570.535 -148.857 701.128 -172.6C805.261 -191.53 850.091 -120.853 863.059 -76.9446C869.248 -55.966 870.82 26.0293 813.677 27.2002C619.753 31.2333 464.37 243.751 370.879 57.9037C332.959 -17.4891 273.393 -192.148 461.325 -201.775Z",
    fill: "#FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_131_26",
    x1: 293,
    y1: 0,
    x2: 293,
    y2: 344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8258F3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgAdvanced9);
export default __webpack_public_path__ + "static/media/bg-advanced9.faca0e14a924b950d3085a62cc93188a.svg";
export { ForwardRef as ReactComponent };